// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom_flow_rule.el-popover{border-color:#d4d4d4;box-shadow:0 1px 10px 0 rgba(0,0,0,.1);margin-top:10px;padding:12px 15px;width:332px}.custom_flow_rule.el-popover .rule_list{color:#666;font-size:12px;line-height:1.5}.custom_flow_rule.el-popover .rule_list .rule_item{margin-top:5px}.custom_flow_rule.el-popover .rule_list .stress{color:#282729;font-weight:700}.custom_flow_rule.el-popover .popper__arrow{display:none}", ""]);
// Exports
module.exports = exports;
